export default __webpack_public_path__ + "static/media/barber.face1339.webp";